module.exports = __webpack_public_path__ + "media/images/avatar_female5-4e78fd9f6c2c416eb9ffa803607af600.png";